export default {
  brand: 'Basetao Spreadsheet',
  nav: {
    home: 'Inicio',
    guide: 'Guía de compra',
    categories: 'Categorías',
  },
  buttons: {
    basetaoSpreadsheet: 'Basetao Spreadsheet',
    buyNow: 'Comprar ahora',
    readGuide: 'Leer la guía',
    visitMainSite: 'Visitar el sitio principal',
    browseCategories: 'Explorar categorías',
  },
  lang: {
    label: 'Idioma',
    english: 'English',
    french: 'Français',
    german: 'Deutsch',
    spanish: 'Español',
    portuguese: 'Português',
  },
  footer: {
    tagline: 'Tu recurso independiente de Basetao Spreadsheet.',
    disclaimer:
      'Este sitio web es un recurso informativo independiente y no es el sitio web oficial de Basetao, salvo que se indique explícitamente.',
    categoriesTitle: 'Categorías',
    resourcesTitle: 'Recursos',
    guideLink: 'Guía de Basetao Spreadsheet',
    mainSiteLink: 'Sitio principal',
    rights: 'Todos los derechos reservados.',
  },
  notFound: {
    title: 'Página no encontrada',
    desc: 'La página que buscas puede haber sido movida o ya no existe. Vuelve al inicio o visita el sitio principal para seguir comprando.',
    backHome: 'Volver al inicio',
  },
};